import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-wrapper"}},[_c(VProgressCircular,{attrs:{"size":"220","width":"7","color":"#20a8d8","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }